import React from "react";
import { Container } from "react-bootstrap";
import { config } from "../../config/portalConfig";
const Footer = () => {
  return (
    <footer className="app-footer py-2">
      <Container fluid>
        <div className="text-center">
          <p className="mb-0">
            Copyright © {new Date().getFullYear()} {config.footerText}. All
            rights reserved | Powered by {config.footerText}
          </p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;